Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign2 = require("lodash/assign");

var _assign3 = _interopRequireDefault(_assign2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _jsxFileName = "src/victory-primitives/area.js";

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _collection = require("../victory-util/collection");

var _collection2 = _interopRequireDefault(_collection);

var _helpers = require("../victory-util/helpers");

var _helpers2 = _interopRequireDefault(_helpers);

var _d3Shape = require("d3-shape");

var d3Shape = _interopRequireWildcard(_d3Shape);

var _commonProps = require("./common-props");

var _commonProps2 = _interopRequireDefault(_commonProps);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Area = function (_React$Component) {
  _inherits(Area, _React$Component);

  function Area() {
    _classCallCheck(this, Area);

    return _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).apply(this, arguments));
  }

  _createClass(Area, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _calculateAttributes = this.calculateAttributes(this.props),
          style = _calculateAttributes.style,
          areaPaths = _calculateAttributes.areaPaths,
          linePaths = _calculateAttributes.linePaths;

      this.style = style;
      this.areaPaths = areaPaths;
      this.linePaths = linePaths;
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _calculateAttributes2 = this.calculateAttributes(nextProps),
          style = _calculateAttributes2.style,
          areaPaths = _calculateAttributes2.areaPaths,
          linePaths = _calculateAttributes2.linePaths;

      var _props = this.props,
          className = _props.className,
          interpolation = _props.interpolation;

      if (!_collection2.default.allSetsEqual([[className, nextProps.className], [interpolation, nextProps.interpolation], [linePaths, this.linePaths], [areaPaths, this.areaPaths], [style, this.style]])) {
        this.style = style;
        this.areaPaths = areaPaths;
        this.linePaths = linePaths;
        return true;
      }

      return false;
    }
  }, {
    key: "calculateAttributes",
    value: function calculateAttributes(props) {
      var style = props.style,
          data = props.data,
          active = props.active,
          scale = props.scale;
      var dataSegments = this.getDataSegments(data);
      var xScale = scale.x;
      var yScale = scale.y;
      var interpolation = this.toNewName(props.interpolation);
      var areaFunction = d3Shape.area().curve(d3Shape[interpolation]).x(function (d) {
        return xScale(d._x1 !== undefined ? d._x1 : d._x);
      }).y1(function (d) {
        return yScale(d._y1 !== undefined ? d._y1 : d._y);
      }).y0(function (d) {
        return yScale(d._y0);
      });
      var lineFunction = d3Shape.line().curve(d3Shape[interpolation]).x(function (d) {
        return xScale(d._x1 !== undefined ? d._x1 : d._x);
      }).y(function (d) {
        return yScale(d._y1);
      });
      return {
        style: _helpers2.default.evaluateStyle((0, _assign3.default)({
          fill: "black"
        }, style), data, active),
        areaPaths: dataSegments.map(function (segment) {
          return areaFunction(segment);
        }),
        linePaths: dataSegments.map(function (segment) {
          return lineFunction(segment);
        })
      };
    }
  }, {
    key: "getDataSegments",
    value: function getDataSegments(data) {
      return _collection2.default.splitArray(data, function (datum) {
        var yDatum = datum.y1 !== undefined ? datum._y1 : datum._y;
        return yDatum === null || typeof yDatum === "undefined";
      }).filter(function (segment) {
        return segment.length > 1;
      });
    }
  }, {
    key: "toNewName",
    value: function toNewName(interpolation) {
      var capitalize = function capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
      };

      return "curve" + capitalize(interpolation);
    }
  }, {
    key: "renderArea",
    value: function renderArea(paths, style, events) {
      var areaStroke = style.stroke ? "none" : style.fill;
      var areaStyle = (0, _assign3.default)({}, style, {
        stroke: areaStroke
      });
      var _props2 = this.props,
          role = _props2.role,
          shapeRendering = _props2.shapeRendering,
          className = _props2.className;
      return paths.map(function (path, index) {
        return _react2.default.createElement("path", _extends({
          key: "area-" + index,
          style: areaStyle,
          shapeRendering: shapeRendering || "auto",
          role: role || "presentation",
          d: path,
          className: className
        }, events, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 88
          }
        }));
      });
    }
  }, {
    key: "renderLine",
    value: function renderLine(paths, style, events) {
      if (!style.stroke || style.stroke === "none" || style.stroke === "transparent") {
        return [];
      }

      var _props3 = this.props,
          role = _props3.role,
          shapeRendering = _props3.shapeRendering,
          className = _props3.className;
      var lineStyle = (0, _assign3.default)({}, style, {
        fill: "none"
      });
      return paths.map(function (path, index) {
        return _react2.default.createElement("path", _extends({
          key: "area-stroke-" + index,
          style: lineStyle,
          shapeRendering: shapeRendering || "auto",
          role: role || "presentation",
          d: path,
          className: className
        }, events, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 110
          }
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          events = _props4.events,
          groupComponent = _props4.groupComponent;
      var areas = this.renderArea(this.areaPaths, this.style, events);
      var lines = this.renderLine(this.linePaths, this.style, events);
      var children = [].concat(_toConsumableArray(lines), _toConsumableArray(areas));
      return children.length === 1 ? children[0] : _react2.default.cloneElement(groupComponent, {}, children);
    }
  }]);

  return Area;
}(_react2.default.Component);

Area.propTypes = _extends({}, _commonProps2.default, {
  groupComponent: _propTypes2.default.element,
  interpolation: _propTypes2.default.string
});
Area.defaultProps = {
  groupComponent: _react2.default.createElement("g", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    }
  })
};
exports.default = Area;